import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { ProfileAddress } from '../ProfileAddress'
import { InitialControllerAddress } from './InitialControllerAddress'
import { InitialChainID } from './InitialChainID'
import { PrimaryContractDeployment } from './PrimaryContractDeployment'
import { SecondaryContractDeployment } from './SecondaryContractDeployment'
import { PostDeploymentModule } from './PostDeploymentModule'
import { PostDeploymentModuleCalldata } from './PostDeploymentModuleCalldata'
import { ReadyEncodedCrossDeployCalldata } from './ReadyEncodedCrossDeployCalldata'
import { LinkedContractsFactoryAddress } from '@/business-logic/wallet/domain/cross-chain-deployment/LinkedContractsFactoryAddress'

// "profileAddress": "0xa8eF14533CcfD44b281B1FFD098B6CdfcA39a247",
// "initialControllerAddress": "0x91488301Db0812d7302Ba4AA0F035865A8a7A8F7",
// "initialControllerPrivateKey": "0xd57bdbe1be9af5f286d3a6476920c372a965441262c3b14a..",
// "initialChainID": 42,
// "privateKeyID": 2
// "readyEncodedCrossDeployCalldata": "0x......",
// "primaryContractDeployment": {
//   "salt": "0x65845cc4e77a4c76db68c2e9c5f1606e818cf077bfeedbb19c0d89d6a1c255f0",
//   "fundingAmount": 0,
//   "implementationContract": "0x91488301...",
//   "initializationCalldata": "0x91488301...",
// },
// "SecondaryContractDeployment": {
//   "fundingAmount": 0,
//   "implementationContract": "0x91488301...",
//   "initializationCalldata": "0x91488301...",
//   "addPrimaryContractAddress": true,
//   "extraInitializationParams": "0x", // 0x
// },
// "postDeploymentModule": "0x91488301...",
// "postDeploymentModuleCalldata": "0x91488301...",
// "linkedContractsFactoryAddress": "0x91488301...",

export const CrossChainDeploymentPackagePropsSchema = z.object({
  profileAddress: z.instanceof(ProfileAddress),
  initialControllerAddress: z.instanceof(InitialControllerAddress),
  initialChainID: z.instanceof(InitialChainID),
  // TODO<BACKUP>: will be filled in with backup & restore PR
  //privateKeyID: z.instanceof(PrivateKeyID).optional(),
  primaryContractDeployment: z.instanceof(PrimaryContractDeployment),
  secondaryContractDeployment: z.instanceof(SecondaryContractDeployment),
  postDeploymentModule: z.instanceof(PostDeploymentModule),
  postDeploymentModuleCalldata: z.instanceof(PostDeploymentModuleCalldata),
  readyEncodedCrossDeployCalldata: z.instanceof(
    ReadyEncodedCrossDeployCalldata
  ),
  linkedContractsFactoryAddress: z.instanceof(LinkedContractsFactoryAddress),
})

export type CrossChainDeploymentPackageProps = z.infer<
  typeof CrossChainDeploymentPackagePropsSchema
>

export class CrossChainDeploymentPackage extends ValueObject<CrossChainDeploymentPackageProps> {
  public getProfileAddress(): ProfileAddress {
    return this.props.profileAddress
  }

  public getInitialControllerAddress(): InitialControllerAddress {
    return this.props.initialControllerAddress
  }

  public getInitialChainID(): InitialChainID {
    return this.props.initialChainID
  }

  public getPrimaryContractDeployment(): PrimaryContractDeployment {
    return this.props.primaryContractDeployment
  }

  public getSecondaryContractDeployment(): SecondaryContractDeployment {
    return this.props.secondaryContractDeployment
  }

  public getPostDeploymentModule(): PostDeploymentModule {
    return this.props.postDeploymentModule
  }

  public getPostDeploymentModuleCalldata(): PostDeploymentModuleCalldata {
    return this.props.postDeploymentModuleCalldata
  }

  public getReadyEncodedCrossDeployCalldata(): ReadyEncodedCrossDeployCalldata {
    return this.props.readyEncodedCrossDeployCalldata
  }

  public getLinkedContractsFactoryAddress(): LinkedContractsFactoryAddress {
    return this.props.linkedContractsFactoryAddress
  }

  public static create(
    props: CrossChainDeploymentPackageProps
  ): CrossChainDeploymentPackage {
    const validatedProps = CrossChainDeploymentPackagePropsSchema.parse(props)
    return new CrossChainDeploymentPackage(validatedProps)
  }
}
